import {Component, Input, ViewChild} from '@angular/core';
import { NavController, NavParams, Content, ModalController } from 'ionic-angular';
import { CommonProvider } from '../../../providers/common';
import { NetworkPage } from '../network/network';

import { PostPage } from '../post/post';
import { FeedFocusComponent } from '../profile/feed-focus/feed-focus.component';
import { ProfilePage } from '../profile/profile';
import {query} from "@angular/core/src/animation/dsl";


@Component({
  selector: 'page-search',
  templateUrl: 'search.html',
})
export class SearchPage {
  _query: string;

  @Input()
  set query(val: string) {
    this._query = val;
    this.sendQuery();
  }

  showResult: boolean = false;
  activeSegment: string = '0';

  //
  posts: any = null;
  users: any = null;
  clubs: any = null;
  @ViewChild('content') content: Content;

  constructor(public navCtrl: NavController, public navParams: NavParams, public commonProvider: CommonProvider, public modalCtrl: ModalController) {
  }

  ionViewDidLoad() {
  }

  sendQuery(){
    if(this._query.length > 0){
      this.commonProvider.searchAll(this._query).subscribe((res) => {
        if(res.success){
          this.posts = res.data.PostJson;
          this.clubs = res.data.ClubJson;
          this.users = res.data.UserJson;
          if(this.users == undefined){
            this.users = res.data.UserBisJson;
          }
        }
      })
    }
  }

  toggleResult(value = true) {
    this.showResult = value;
    this.content.resize();
  }

  goToProfile(user_id) {
    this.modalCtrl.create(ProfilePage, {userId : user_id}).present().then(() => {});

  }

  seePost(postId, clubId) {
    if(clubId !== null){
      let modal = this.modalCtrl.create(FeedFocusComponent, {postId: postId, isClubFeed: true, clubId: clubId});
      modal.present().then(() => {});
    }else{
      let modal = this.modalCtrl.create(FeedFocusComponent, {postId: postId, isClubFeed: false});
      modal.present().then(() => {});
    }
  }

  goToClubs() {
    this.navCtrl.push(NetworkPage, {})
    .then(() => {
    })
  }

  goToPost(postId) {
    this.navCtrl.push(PostPage, {
      postId: postId
    })
      .then(() => {
      });
  }

    // Decoding image buffer
    ab2str(arraybuffer) {
      return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer))
    }

}



// WEBPACK FOOTER //
// ./src/pages/employee/search/search.ts